var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import RcSlider from 'rc-slider';
import { cloneElement } from 'react';
import { Tooltip } from '@snack-uikit/tooltip';
import { DATA_SWIPE_DIRECTIONS_ATTRIBUTE } from '@snack-uikit/utils';
import styles from './styles.module.css';
const addSwipeAttribute = (node) => cloneElement(node, { [DATA_SWIPE_DIRECTIONS_ATTRIBUTE]: 'Left Right' });
const tipHandleRender = (tipFormatter) => function (node, handleProps) {
    return (_jsx(Tooltip, { tip: tipFormatter ? tipFormatter(handleProps.value) : handleProps.value, open: handleProps.dragging || undefined, disableSpanWrapper: true, trigger: 'hoverAndFocusVisible', className: styles.tipWrapper, children: addSwipeAttribute(node) }));
};
export function Slider(_a) {
    var { className, handleTip, tipFormatter } = _a, props = __rest(_a, ["className", "handleTip", "tipFormatter"]);
    return (_jsx(RcSlider, Object.assign({ className: cn('osThemeSnack', className, {
            withMarks: Boolean(props.marks),
            reverse: Boolean(props.reverse),
        }), handleRender: handleTip ? tipHandleRender(tipFormatter) : addSwipeAttribute }, props), JSON.stringify(props.marks)));
}
